import React, { FC, useEffect } from 'react';
import { LogoV2 } from 'src/components';

import PosterImg from './assets/dancer_poster.webp';
import fullyUncensoredImg from './assets/fully_uncensored.webp';
import { useLoadingProgress } from '../../../../hooks';

import styles from './dancer-fullscreen-loader.module.scss';

const LOADING_TIME = 3500;
const START_RANGE = 0;
const END_RANGE = 100;

type Props = {
  onStarted?: () => void;
  onFinished?: () => void;
};

const DancerFullscreenLoader: FC<Props> = ({ onStarted, onFinished }) => {
  const handleFinishLoading = () => {
    onFinished?.();
  };

  const { progress } = useLoadingProgress({
    onDone: handleFinishLoading,
    loadingRanges: [{ range: [START_RANGE, END_RANGE], time: LOADING_TIME }],
  });

  useEffect(() => {
    onStarted?.();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <LogoV2 />
        </div>

        <div className={styles.asset}>
          <video poster={PosterImg} autoPlay loop muted className={styles.asset__video}>
            <source src="/media/dancer_366kb.mp4" type="video/mp4" media="(max-width: 768px)" />
            <source src="/media/dancer_618kb.mp4" type="video/mp4" />
          </video>

          <img src={fullyUncensoredImg} alt="" className={styles.asset__uncensored} />
        </div>

        <div className={styles.spinner}>
          <span>Loading</span>
          <div className={styles.spinner__animation} />
        </div>

        <div className={styles.progress}>
          <div className={styles.progress__bar_outer}>
            <div
              className={styles.progress__bar_inner}
              style={{
                transform: `translateX(${progress.percents - END_RANGE}%)`,
              }}
            />
            <span className={styles.progress__label}>{progress.percents}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DancerFullscreenLoader };
